import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { QuickDeliveryHandlingPolicy } from './field-work.models';
import { FieldWorkService } from './field-work.service';

@Component({
  selector: 'app-quick-delivery-handling-policy-dialog',
  standalone: true,
  imports: [
    CommonModule, FormsModule, ButtonModule, CheckboxModule, DialogModule,
    IftaLabelModule, InputGroupModule, InputGroupAddonModule, InputNumberModule
  ],
  templateUrl: './quick-delivery-handling-policy-dialog.component.html',
  styleUrls: ['./quick-delivery-handling-policy-dialog.component.css']
})
export class QuickDeliveryHandlingPolicyDialogComponent implements OnChanges {
  private readonly service = inject(FieldWorkService);

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter<QuickDeliveryHandlingPolicy>();

  policy: QuickDeliveryHandlingPolicy = {};
  loading = false;
  saving = false;
  error = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true) this.load();
  }

  close(): void {
    if (!this.loading && !this.saving) this.visibleChange.emit(false);
  }

  save(): void {
    if (this.loading || this.saving) return;
    if (this.policy.maxAutoApproveAmount != null && this.policy.maxAutoApproveAmount <= 0) {
      this.error = 'The auto-approval limit must be greater than zero, or clear it for no amount limit.';
      return;
    }
    this.error = '';
    this.saving = true;
    this.service.saveQuickDeliveryHandlingPolicy(this.policy).pipe(finalize(() => this.saving = false)).subscribe({
      next: policy => {
        this.policy = policy;
        this.saved.emit(policy);
        this.visibleChange.emit(false);
      },
      error: error => this.error = error?.error?.message || error?.error?.error || 'Could not save the quick-handling policy.'
    });
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.service.quickDeliveryHandlingPolicy().pipe(finalize(() => this.loading = false)).subscribe({
      next: policy => this.policy = { ...policy },
      error: error => this.error = error?.error?.message || error?.error?.error || 'Could not load the quick-handling policy.'
    });
  }
}
